import PasswordValidator from 'password-validator';

function passwordStrength(val) {
  const validator = new PasswordValidator();

  validator
    .is()
    .min(8)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .digits()
    .has()
    .symbols();

  const misses = validator.validate(val, { list: true });

  const criteriaList = {
    digits_symbols: { message: 'Including numbers or symbols', code: 'digits_symbols', match: false },
    uppercase_lowercase: { message: 'Mixing upper/lowercase', code: 'uppercase_lowercase', match: false },
    password_length: { message: 'A password at least 8 characters long', code: 'password_length', match: false },
  };

  let message = 'Weak';
  let strength = 0;
  let color = 'red';

  criteriaList.digits_symbols.match = !misses.includes('digits') || !misses.includes('symbols');
  criteriaList.uppercase_lowercase.match = !misses.includes('lowercase') && !misses.includes('uppercase');
  criteriaList.password_length.match = !misses.includes('min');

  if (criteriaList.digits_symbols.match) {
    strength += 1;
  }
  if (criteriaList.uppercase_lowercase.match) {
    strength += 1;
  }
  if (criteriaList.password_length.match) {
    strength += 1;
  }

  if (strength === 1) {
    color = 'red';
    message = 'Poor';
  } else if (strength === 2) {
    color = 'gold';
    message = 'Almost There';
  } else if (strength === 3) {
    color = 'green';
    message = 'Strong';
  }

  return { strength, criteriaList: Object.values(criteriaList), message: { text: message, color } };
}

export default passwordStrength;
